import React, { useMemo, useState } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Collapse } from "react-bootstrap";
import { faArrowRight, faArrowDown } from "@fortawesome/free-solid-svg-icons";
import menuItems from "./menu-items";
import MenuItem from "./components/MenuItem";

const Sidebar = (props) => {
  const { userRoles } = props;
  const [activeMenu, setActiveMenu] = useState(-1);

  const userRoleNames = useMemo(() => userRoles, [userRoles]);

  const getCollapseId = (url) => `sidebar-menu-collapse-${url}`;

  const menuRecursive = (items) => items.map((menuItem, index) => {
    if (menuItem.roles && userRoleNames.indexOf(menuItem.roles) === -1) return null;
    if (menuItem.items && menuItem.items.length) {
      return (
        <React.Fragment key={index}>
          <button
            onClick={() => setActiveMenu((prevIndex) => ((prevIndex === index) ? -1 : index))}
            className={`d-flex justify-content-between nav-link ${activeMenu === index ? "active" : ""}`}
            aria-controls={getCollapseId(index)}
            aria-expanded={index === activeMenu}
          >
           <div>
             <FontAwesomeIcon icon={menuItem.icon} title={menuItem.title}/>
             <span className="ml-2">{menuItem.title}</span>
           </div>
             <FontAwesomeIcon className="sidebar-item-arrow" icon={activeMenu === index ? faArrowDown : faArrowRight} />
          </button>
          <Collapse in={activeMenu === index}>
            <div id={getCollapseId(index)}>
              {menuRecursive(menuItem.items)}
            </div>
          </Collapse>
        </React.Fragment>
      );
    }
    return <MenuItem key={index} item={menuItem} pathname={props.pathname}/>;
  });

  return (
    <div className="sidebar">
      <nav className="sidebar-nav">
        <ul className="nav">
          {menuRecursive(menuItems)}
          {/* {menuItems.map(menuItem => {
            if (menuItem.roles && userRoleNames.indexOf(menuItem.roles) === -1) return null;

            return <MenuItem key={menuItem.url} item={menuItem} pathname={props.pathname}/>;
          })} */}
        </ul>
      </nav>
      <button className="sidebar-minimizer" type="button"/>
    </div>
  );
};

const mapStateToProps = state => ({
  userRoles: state.auth.roles,
  pathname: state.router.location.pathname
});

export default connect(
  mapStateToProps
)(Sidebar);



// WEBPACK FOOTER //
// ./src/views/layout/sidebar.js